import React, { useEffect, useState } from 'react';
import { LuLayoutDashboard } from "react-icons/lu";
import { HiOutlineShoppingCart } from "react-icons/hi2";
import { PiDownloadSimpleBold } from "react-icons/pi";
import { MdOutlineLogout } from "react-icons/md";
import Dashboard from './Dashboard';
import SettingApi from '../api/SettingApi';
import MySubscription from './MySubscription';
import UserApi from '../api/UserApi';



//   const checkUser = async () => {
//     try {
//       const response = await AccountApi.user();
//       if (response) {
//         setUser(response.user.data);
//       } else {
//         setUser(null);
//       }
//     } catch (error) {
//       console.error("Auth check failed", error);
//     }
//   };

//   const handleLogout = async () => {
//     try {
//       await AccountApi.logout();
//       setUser(null);
//     } catch (error) {
//       console.error("Logout error:", error.response ? error.response.data : error);
//     }
//   };

//   const getSettings = async () => {
//     const res = await SettingApi.index();
//     setSetting(res);
//   };

//   useEffect(() => {
//     checkUser();
//     getSettings();
//   }, []);

//   const tabs = [
//     { id: "dashboard", label: "Dashboard", icon: <LuLayoutDashboard size={16} /> },
//     { id: "subscriptions", label: "Subscriptions", icon: <HiOutlineShoppingCart size={16} /> },
//     { id: "downloads", label: "Downloads", icon: <PiDownloadSimpleBold size={16} /> },
//   ];

//   const renderTabContent = () => {
//     switch (activeTab) {
//       case "dashboard":
//         return <Dashboard user={user} />;
//       case "subscriptions":
//         return <MySubscription user={user} />;
//       case "downloads":
//         return <MySubscription user={user} />;
//       default:
//         return null;
//     }
//   };

//   return (
//     <div className="max-w-[1420px] mx-auto px-6 py-4">
//       <h1 className="text-3xl text-start font-bold">My Account</h1>

//       <div className="w-full flex sm:flex-col md:flex-row lg:flex-row xl:flex-row gap-2 mt-4 sm:flex-wrap md:flex-nowrap">
//         <ul className="flex sm:flex-row sm:gap-x-3 md:flex-col lg:flex-col xl:flex-col sm:flex-wrap md:flex-nowrap text-sm font-medium text-gray-500 dark:text-gray-400 ">
//           {tabs.map((tab) => (
//             <li key={tab.id}>
//               <button
//                 onClick={() => {
//                   // Only allow interaction with "Subscriptions" and "Downloads" if the user is logged in
//                   if (user || tab.id === "dashboard") {
//                     setActiveTab(tab.id);
//                   }
//                 }}
//                 className={`inline-flex gap-1 mb-3 items-center px-4 py-3 rounded-lg w-full ${
//                   activeTab === tab.id
//                     ? "bg-gray-200 dark:bg-gray-700 text-gray-900 dark:text-white"
//                     : "bg-gray-50 hover:bg-gray-100 dark:bg-gray-800 dark:hover:bg-gray-700 dark:text-gray-400"
//                 } ${!(user) && (tab.id === "subscriptions" || tab.id === "downloads") ? "cursor-not-allowed opacity-50" : ""}`} // Disable only the "subscriptions" and "downloads" tabs if the user is not logged in
//               >
//                 {tab.icon} {tab.label}
//               </button>
//             </li>
//           ))}
//           <li>
//             {user ? (
//               <button
//                 onClick={handleLogout}
//                 className="inline-flex gap-1 items-center px-4 py-3 rounded-lg text-red-600 font-semibold bg-gray-50 hover:bg-gray-100 w-full dark:bg-gray-800 dark:hover:bg-gray-700 dark:hover:text-white"
//               >
//                 <MdOutlineLogout size={16} />
//                 Logout
//               </button>
//             ) : (
//               <a
//                 href={`${setting?.home_url}/login`}
//                 className="inline-flex gap-1 items-center px-4 py-3 rounded-lg hover:text-gray-900 bg-gray-50 hover:bg-gray-100 w-full dark:bg-gray-800 dark:hover:bg-gray-700 dark:hover:text-white"
//               >
//                 <MdOutlineLogout size={16} />
//                 Login
//               </a>
//             )}
//           </li>
//         </ul>

//         <div className="p-6 bg-gray-50 text-medium text-gray-500 dark:text-gray-400 dark:bg-gray-800 rounded-lg w-full">
//           <h3 className="text-lg font-bold text-gray-900 dark:text-white mb-2">
//             {tabs.find((tab) => tab.id === activeTab)?.label}
//           </h3>
//           {renderTabContent()}
//         </div>
//       </div>
//     </div>
//   );
// };
const MyProfile = () => {
  const [activeTab, setActiveTab] = useState("dashboard");
  const [user, setUser] = useState(null);
  const [setting, setSetting] = useState(null);

  const checkUser = async () => {
    try {
      const response = await UserApi.user();
      if (response) {
        setUser(response.user.data);
      } else {
        setUser(null);
      }
    } catch (error) {
      console.error("Auth check failed", error);
    }
  };

  const handleLogout = async () => {
    try {
      await UserApi.logout();
      setUser(null);
    } catch (error) {
      console.error("Logout error:", error.response ? error.response.data : error);
    }
  };

  const getSettings = async () => {
    const res = await SettingApi.index();
    setSetting(res);
  };

  useEffect(() => {
    checkUser();
    getSettings();
  }, []);

  const tabs = [
    { id: "dashboard", label: "Dashboard", icon: <LuLayoutDashboard size={16} /> },
    { id: "subscriptions", label: "Subscriptions", icon: <HiOutlineShoppingCart size={16} /> },
    { id: "downloads", label: "Downloads", icon: <PiDownloadSimpleBold size={16} /> },
  ];

  const renderTabContent = () => {
    switch (activeTab) {
      case "dashboard":
        return <Dashboard user={user} />;
      case "subscriptions":
        return <MySubscription user={user} />;
      case "downloads":
        return <MySubscription user={user} />;
      default:
        return null;
    }
  };

  return (
    <div className="max-w-[1420px] mx-auto px-6 py-4">
      <h1 className="text-3xl text-start font-bold">My Account</h1>

      <div className="w-full flex sm:flex-col md:flex-row lg:flex-row xl:flex-row gap-2 mt-4 sm:flex-wrap md:flex-nowrap">
        <ul className="flex sm:flex-row sm:gap-x-3 md:flex-col lg:flex-col xl:flex-col sm:flex-wrap md:flex-nowrap text-sm font-medium text-gray-500 dark:text-gray-400 ">
          {tabs.map((tab) => (
            <li key={tab.id}>
              <button
                onClick={() => {
                  if (user || tab.id === "dashboard") {
                    setActiveTab(tab.id);
                  }
                }}
                className={`inline-flex gap-1 mb-3 items-center px-4 py-3 rounded-lg w-full ${
                  activeTab === tab.id
                    ? "bg-gray-200 dark:bg-gray-700 text-gray-900 dark:text-white"
                    : "bg-gray-50 hover:bg-gray-100 dark:bg-gray-800 dark:hover:bg-gray-700 dark:text-gray-400"
                } ${!(user) && (tab.id === "subscriptions" || tab.id === "downloads") ? "cursor-not-allowed opacity-50" : ""}`} 
              >
                {tab.icon} {tab.label}
              </button>
            </li>
          ))}
          <li>
            {user ? (
              <button
                onClick={handleLogout}
                className="inline-flex gap-1 items-center px-4 py-3 rounded-lg text-red-600 font-semibold bg-gray-50 hover:bg-gray-100 w-full dark:bg-gray-800 dark:hover:bg-gray-700 dark:hover:text-white"
              >
                <MdOutlineLogout size={16} />
                Logout
              </button>
            ) : (
              <a
                href={`${setting?.home_url}/login`}
                className="inline-flex gap-1 items-center px-4 py-3 rounded-lg hover:text-gray-900 bg-gray-50 hover:bg-gray-100 w-full dark:bg-gray-800 dark:hover:bg-gray-700 dark:hover:text-white"
              >
                <MdOutlineLogout size={16} />
                Login
              </a>
            )}
          </li>
        </ul>

        <div className="p-6 bg-gray-50 text-medium text-gray-500 dark:text-gray-400 dark:bg-gray-800 rounded-lg w-full">
          <h3 className="text-lg font-bold text-gray-900 dark:text-white mb-2">
            {tabs.find((tab) => tab.id === activeTab)?.label}
          </h3>
          {renderTabContent()}
        </div>
      </div>
    </div>
  );
};


export default MyProfile;
